import { ShippingType } from '@allesauto/graphql';
import { DeliveryTime } from '@allesauto/graphql/src/mock/schema';
import { Maybe } from 'graphql/jsutils/Maybe';

export function convertDeliveryTimeToString(
  deliveryTime: Maybe<DeliveryTime>
): string {
  if (!deliveryTime) return '';

  return `${deliveryTime.minWorkdays} - ${deliveryTime.maxWorkdays} Werktage`;
}

export function mapAccessoryShippingType(type: ShippingType): string {
  switch (type) {
    case ShippingType.AccessoryPickUp:
      return 'Abholbereit';
    case ShippingType.AccessoryDelivery:
      return 'Versandbereit';
    case ShippingType.AccessoryPickUpWithInstallation:
      return 'Montagebereit';
    default:
      return '';
  }
}
